<template>
  <div
    :style="{ 'height': $store.state.screenHeight + 'px' }"
    class="d-flex justify-content-center align-items-center"
  >
    <i class="fas fa-sync-alt fa-spin fa-3x fa-fw"></i>
    <!-- {{ $route.params.key }} -->
    <!-- <form
      ref="printInvoceAll"
      method="post"
      action="http://192.168.64.2/VillageService/pdf/invoice_all.php"
    > -->
      <form
      ref="printInvoceAll"
      method="post"
      action="/pdf/invoice_all.php"
    >
      <input
        type="hidden"
        name="data_invoice"
      />
      <input
        type="hidden"
        name="description"
      />
      <input
        type="hidden"
        name="config"
      />
    </form>
  </div>
</template>

<script>
import api from '../services/service_invoice'
export default {
  methods: {
    exportPDF () {
      api.getPublicInvoice(
        this.$route.params.key,
        this.header,
        result => {
          if (result.response === true) {
            document.getElementsByName(
              'data_invoice'
            )[0].value = JSON.stringify(result.data.pagination)
            document.getElementsByName('config')[0].value =
              sessionStorage.config
            this.$refs.printInvoceAll.submit()
          } else {
            alert(result.message)
          }
        },
        error => {
          alert(JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.exportPDF()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/invoice_public.vue